// External libraries
//@ts-expect-error untyped module
import { capitalizeFirst } from '@checkout/react-components';

// Internal modules
import { appStore } from '@/store';
import { features } from '@/lib';
import type { NoneAddressInputs } from '@/store/models/form/types';

export const uncheckPreviousTermBox = (option: string): void => {
  const { updateNonAddressField } = appStore.getActions().form;

  const prevOption = option === 'guest' ? 'signup' : 'guest';
  const prevOptionInCap: 'Guest' | 'Signup' = capitalizeFirst(prevOption);
  const termsCheckboxField: keyof NoneAddressInputs = `${prevOption}AgreeToTerms`;

  updateNonAddressField({
    field: termsCheckboxField,
    payload: {
      displayError: false,
      error: '',
      errorCode: 'valueMissing',
      isValid: features.isNotActive(
        `has${prevOptionInCap}TermsAndConditionsCheckbox`,
      ),
      value: false,
    },
  });
};
